import React, { useEffect } from 'react';
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import Footer from '../Components/Footer';
import HeaderUser from '../Components/HeaderUser';
import SidebarUser from '../Components/SidebarUser';
import { UserContext } from '../Context/UserContext';
import { GuestApi } from '../utils/api';
import '../assets/css/dashboard-theme.css';

const UserAuthLayout = (props) => {
  const { children } = props;

  const { user, setUser } = useContext(UserContext);

  const logoutHandle = async () => {
    try {
      const { refreshToken } = user;
      await GuestApi.post('/user/logout', { refreshToken });
    } catch (e) {
      const { response } = e;
      console.log(`😱 Axios request failed: ${response}`);
    }
    localStorage.removeItem('user_data');
    setUser(null);
    window.localStorage.clear();
    window.location.reload();
  };

  if (user == null) return <Navigate to='/' />;

  return (
    <div className='dashboard-layout-wrapper'>
      {/* Background glow effect similar to GuestLayout */}
      <div
        className='hero-bg-glow'
        style={{
          position: 'fixed',
          top: '-30%',
          right: '-30%',
          width: '80%',
          height: '80%',
          opacity: 0.1,
        }}
      ></div>

      <SidebarUser logoutHandle={logoutHandle} />
      <main className='main-content position-relative border-radius-lg'>
        <HeaderUser logoutHandle={logoutHandle} />
        <div className='container-fluid py-4'>{children}</div>
        <Footer />
      </main>
    </div>
  );
};

export default UserAuthLayout;
